import { connect } from "react-redux";

var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

require("org/roster_upload/add_students_class_code.scss");

@connect(
	(state, props) => ({
    	studentLists: RosterSelectors.studentLists({ state })
	}),

	(dispatch, props) => (
		{
			updateStudentList: (id,update) => {
				const promises = [];
				if (!_.isEmpty(update)) {
					promises.push(dispatch(RosterActions.updateStudentList({
						id: id, update
					})));
				}
				return Promise.all(promises);
			},
			fetchStudentLists: function() {
				var embeds = RosterActions.GLOBAL_STUDENT_LIST_EMBEDS
				return dispatch(RosterActions.fetchStudentLists({ embeds }));
			}
		}
	)
	
	
)

class AddStudentsClassCode extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	addPassphrase(e, id){
		console.log('helo')
		$wr.nope(e)
		this.props.updateStudentList(id,{"add_passphrase": true}).then(res=>{
			this.props.fetchStudentLists()
		})
	}

	render() {
		var studentLists = _.sortBy(this.props.studentLists, "name");
		var classCodeRows = _.map(studentLists, (studentList) => {
			if (studentList.passphrase){
				var classLink = WhooosReadingServices.OuterPages.url("/class_code_student", {
					passphrase: studentList.passphrase
				});
				var passphraseSection = studentList.passphrase
			} else {
				var classLink = ""
				var passphraseSection = (
					<a onClick={(e)=>this.addPassphrase(e, studentList.id)}>Add Class Code</a>
				)
			}
			return (
				<tr className="classCodeRow" key={ studentList.id }>
					<td className="name">
						{ studentList.name }
					</td>
					<td className="code">
						{ passphraseSection }
					</td>
					<td className="link">
						<a href={ classLink } target="_blank">
							{ classLink }
						</a>
					</td>
				</tr>
			);
		})
		return (
			<div className="addStudentsClassCode">
				<p>
					Get your students started without having to enter in all of their names yourself.{" "}
					<a href="https://whooosreading.zendesk.com/hc/en-us/articles/115001714992" target="_blank">
						Learn more about <em>Class Codes</em>.
					</a>
				</p>

				<table className="table classCodeTable">
					<tbody>
						<tr>
							<th>Class</th>
							<th>Class Code</th>
							<th>Class Signup Link</th>
						</tr>
						{ classCodeRows }
					</tbody>
				</table>

				<p>
					<em>Class Code</em>: Students should go to <a href={ WhooosReadingServices.OuterPages.url("/") }>
						{ WhooosReadingServices.OuterPages.url("/") }
					</a> > "Login" > "Student" > "Have a Class Code?" > Enter the code.
				</p>
				<p>
					<em>Class Signup Link</em>: Students should copy and paste the link into their browser.
				</p>
			</div>
		)
	}
};

AddStudentsClassCode.WrappedComponent.propTypes = StrictPropTypes({
	studentLists: PropTypes.array.isRequired
});

module.exports = AddStudentsClassCode;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/AddStudentsClassCode.js